import { createTree } from "@/helpers/indexCards";
import { IndexCard } from "@/types";

export const createTreeFilter = (
  filters: { id: string; data: IndexCard }[],
) => {
  const processedFilters: Record<
    string,
    {
      label: string;
      categories: string[];
    }
  > = {};

  for (const filter of filters ?? []) {
    for (const category of filter.data?.categorization ?? []) {
      if (
        category?.parameterName &&
        !(category.parameterName in processedFilters)
      ) {
        processedFilters[category.parameterName] = {
          label: category.name,
          categories:
            typeof category.categories === "string"
              ? [category.categories]
              : [...category.categories],
        };
      } else if (category?.parameterName && category?.categories) {
        for (const value of category.categories) {
          if (
            !processedFilters[category.parameterName].categories.includes(value)
          ) {
            processedFilters[category.parameterName].categories.push(value);
          }
        }
      }
    }
  }
  const treeFilters = Object.entries(processedFilters).map(
    ([name, { label, categories }]) => ({
      name,
      label,
      categories: createTree(categories),
    }),
  );
  return treeFilters;
};
